import { useEffect, useState } from 'react'
import { i18n } from '@fs/zion-locale'
import axios from '@fs/zion-axios'
import { appPath } from '@fs/zion-config'

export default function usePlaceReportsIndex() {
  const [reportsIndex, setReportsIndex] = useState({ regions: [] })
  const [error, setError] = useState(null)
  const locale = i18n.language

  useEffect(() => {
    async function fetchDirectoryContent() {
      try {
        const response = await axios.get(`${appPath}/place-reports/directory-content/`)
        setReportsIndex(response.data)
      } catch (err) {
        console.error('Error fetching markdownFiles content:', err)
        setError(err)
      }
    }

    fetchDirectoryContent()
  }, [locale])

  return { reportsIndex, error }
}
